// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._11pqidpf p{margin-right:0}\n._c3k8idpf p{margin-left:0}\n._clfdidpf p{margin-top:0}\n._otyrmgjw{margin-bottom:var(--ds-space-negative-200,-1pc)}\n._q0a5idpf p{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
